module.exports = __webpack_public_path__ + "img/tumblr.6b9c58e.png";